module.exports = (__webpack_require__(0))(98);


//////////////////
// WEBPACK FOOTER
// delegated ./lib/rlink-flux/index.js from dll-reference rlink_core
// module id = 4
// module chunks = 0